import { gsap } from '../global/gsap';

const initClientLists = (sections) => {
    sections.forEach((section) => {
        const trigger = section.querySelector('.js-clients-trigger');
        const grad = section.querySelector('.js-clients-grad');
        const clientList = section.querySelector('.js-clients-list');
        const height = section.offsetHeight;

        if (height > 620) {
            section.classList.add('is-hidden');
            gsap.set(clientList, {
                height: '400px'
            });
        }

        trigger.addEventListener('click', () => {
            gsap.to(clientList, {
                height: 'auto',
                paddingBottom: '0px'
            });
            gsap.to(grad, {
                autoAlpha: 0,
                height: 0,
                overflow: 'hidden',
                pointerEvents: 'none'
            });
        });
    });
};

export default initClientLists;
